import { useEffect, useState } from "react";
import { api } from "@/api/client";
import { useStore } from "@/state/store";
import type { Evaluation } from "@offsite/shared";
import { EvaluationProgress } from "./EvaluationProgress";
import { EvalDetail } from "./EvalDetail";

export function EvaluationView({ teamNumber }: { teamNumber: number }) {
  const { state } = useStore();
  const [evaluation, setEvaluation] = useState<Evaluation | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const res = await api.evaluations.get(state.auth.token, teamNumber);
        if (!cancelled) {
          setEvaluation(res.evaluation);
          setLoading(false);
        }
      } catch {
        if (!cancelled) setLoading(false);
      }
    };
    load();
    const poll = setInterval(load, 3000);
    return () => {
      cancelled = true;
      clearInterval(poll);
    };
  }, [state.auth.token, teamNumber]);

  if (loading || !evaluation) {
    return <EvaluationProgress />;
  }

  return (
    <div className="eval-board eval-board-mobile">
      <header className="eval-board-head">
        <div className="deck-eyebrow" style={{ color: "var(--svo-blau)" }}>
          Eure Bewertung
        </div>
        <div className="eval-board-topic">
          {evaluation.teamName ? `Team „${evaluation.teamName}"` : `Team ${evaluation.teamNumber}`}{" "}
          · Thema: <strong>{evaluation.topicTitle}</strong>
        </div>
      </header>
      <div className="eval-board-body">
        <EvalDetail evaluation={evaluation} />
      </div>
    </div>
  );
}
